import Fade from "src/components/Fade";

export default function ButtonsGroup({
  children,
  in: inProp,
  appear = true,
  onEntering
}) {
  return (
    <Fade
      in={inProp}
      appear={appear}
      unmountOnExit
      onEnter={onEntering}
      duration={{
        enter: 0.4,
        exit: 0
      }}
    >
      {children}
    </Fade>
  );
}
